import React from 'react';

const ImpressumPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-100">
      {/* Header - Same as landing page */}
      <header className="sticky top-0 z-50 bg-white/70 backdrop-blur-lg border-b border-slate-900/10">
        <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
          <a href="/" className="flex items-center space-x-2 text-2xl font-bold text-slate-800">
            <svg className="w-8 h-8 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
            <span>ThreadIt</span>
          </a>

          <div className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-slate-600 hover:text-emerald-500 transition-colors">Home</a>
            <a href="/pricing" className="text-slate-600 hover:text-emerald-500 transition-colors">Pricing</a>
            <a href="/contact" className="text-slate-600 hover:text-emerald-500 transition-colors">Contact</a>
          </div>

          <div className="hidden md:block">
            <a 
              href="/app" 
              className="inline-block text-center px-6 py-2 rounded-lg font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-100 bg-emerald-500 text-white hover:bg-emerald-600 focus:ring-emerald-500 shadow-lg shadow-emerald-500/30 hover:shadow-xl hover:shadow-emerald-500/40"
            >
              Login
            </a>
          </div>

          <div className="md:hidden">
            <button aria-label="Toggle menu" className="text-slate-800">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </nav>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-6 py-12">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-slate-900 mb-8">Impressum / Legal Notice</h1>
          
          <div className="bg-white rounded-lg shadow-md p-8 space-y-8">
            {/* Company Information */}
            <section>
              <h2 className="text-2xl font-semibold text-slate-800 mb-4">Company Name & Address</h2>
              <div className="text-slate-700 space-y-1">
                <p className="font-medium">Truscova GmbH</p>
                <p>Wilhelm-Liebknicht-Str. 4</p>
                <p>28329 Bremen</p>
                <p>Germany</p>
              </div>
            </section>

            {/* Register Information */}
            <section>
              <h2 className="text-2xl font-semibold text-slate-800 mb-4">Register Information</h2>
              <div className="text-slate-700 space-y-1">
                <p><span className="font-medium">Handelsregister:</span> HRB 38524</p>
                <p><span className="font-medium">Registergericht:</span> Amtsgericht Bremen</p>
              </div>
            </section>

            {/* Representation */}
            <section>
              <h2 className="text-2xl font-semibold text-slate-800 mb-4">Representation</h2>
              <div className="text-slate-700 space-y-1">
                <p><span className="font-medium">Geschäftsführer (Managing Director):</span></p>
                <p>Dr. Muhammad Hassan</p>
              </div>
            </section>

            {/* Contact Information */}
            <section>
              <h2 className="text-2xl font-semibold text-slate-800 mb-4">Contact Information</h2>
              <div className="text-slate-700 space-y-1">
                <p><span className="font-medium">Telefon (Phone):</span> +49 (0) 162 919 6783</p>
                <p><span className="font-medium">E-Mail:</span> hello@threadit.com</p>
              </div>
            </section>

            {/* Tax Information */}
            <section>
              <h2 className="text-2xl font-semibold text-slate-800 mb-4">Tax Information</h2>
              <div className="text-slate-700 space-y-1">
                <p><span className="font-medium">Steuernummer (Tax ID):</span> 60 132 20407</p>
                <p><span className="font-medium">Umsatzsteuer-Identifikationsnummer (VAT ID):</span> DE360065309</p>
              </div>
            </section>

            {/* Disclaimer */}
            <section>
              <h2 className="text-2xl font-semibold text-slate-800 mb-4">Haftungsausschluss (Disclaimer)</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-medium text-slate-800 mb-2">Haftung für Inhalte (Liability for Content)</h3>
                  <p className="text-slate-700 leading-relaxed">
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-medium text-slate-800 mb-2">Haftung für Links (Liability for Links)</h3>
                  <p className="text-slate-700 leading-relaxed">
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                  </p>
                </div>

                <div>
                  <h3 className="text-xl font-medium text-slate-800 mb-2">Urheberrecht (Copyright)</h3>
                  <p className="text-slate-700 leading-relaxed">
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-slate-100 border-t border-slate-200 mt-16">
        <div className="container mx-auto px-6 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8 mb-4 md:mb-0">
              <div className="flex items-center space-x-2 text-xl font-bold text-slate-800">
                <svg className="w-7 h-7 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
                <span>ThreadIt</span>
              </div>
              <div className="flex space-x-6 text-sm text-slate-500">
                <a href="/privacy" className="hover:text-emerald-500 transition-colors">Privacy Policy</a>
                <a href="/terms" className="hover:text-emerald-500 transition-colors">Terms of Service</a>
                <a href="/impressum" className="hover:text-emerald-500 transition-colors">Impressum</a>
              </div>
            </div>
            <div className="flex space-x-6 text-slate-500">
              <a href="/#features" className="hover:text-emerald-500 transition-colors">Features</a>
              <a href="/pricing" className="hover:text-emerald-500 transition-colors">Pricing</a>
              <a href="/contact" className="hover:text-emerald-500 transition-colors">Contact</a>
            </div>
          </div>
          <div className="mt-8 text-center text-slate-500 text-sm">
            <p>&copy; {new Date().getFullYear()} ThreadIt Inc. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ImpressumPage;
